/**
 * 余额调整 — 输入用户 ID 后调用 POST /api/admin/users/:id/adjust-balance
 */
import { useState } from 'react';
import { Alert, Button, Descriptions, InputNumber, Space } from 'antd';
import { OperatorForm } from '../../components/OperatorForm';
import { TOKEN_IDS, type TokenId } from '@uo/shared';
import { useAuthStore } from '../../store/auth';

interface BalancePreview {
  user_id: number;
  asset: string;
  balance_before: string;
  delta: string;
  balance_after: string;
  would_apply?: boolean;
}

export function UserAdjustBalancePage() {
  const [userId, setUserId] = useState<number | null>(null);
  const hasNode = useAuthStore((s) => s.hasNode);
  const canAdjust = hasNode('platform.user.adjust');

  if (!canAdjust) {
    return <Alert type="warning" message="当前账号无余额调整权限" showIcon />;
  }

  return (
    <div>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="也可在「会员列表」中直接对单行点击「调整余额」。"
      />

      <Space align="start" wrap>
        <span>用户 ID：</span>
        <InputNumber min={1} value={userId ?? undefined} onChange={(v) => setUserId(v ?? null)} />
        <Button onClick={() => setUserId(null)}>清除</Button>
      </Space>

      {userId && userId > 0 ? (
        <div style={{ marginTop: 24, maxWidth: 480 }}>
          <OperatorForm<BalancePreview>
            endpoint={`/api/admin/users/${userId}/adjust-balance`}
            fields={[
              {
                name: 'asset',
                label: '资产',
                type: 'select',
                required: true,
                options: TOKEN_IDS.map((t: TokenId) => ({ value: t, label: t.toUpperCase() })),
              },
              {
                name: 'delta',
                label: '变动量（可正可负）',
                type: 'text',
                required: true,
                placeholder: '如 100 或 -50',
              },
              { name: 'note', label: '备注', type: 'textarea', required: true },
            ]}
            renderPreview={(p) => (
              <Descriptions column={1} size="small" bordered>
                <Descriptions.Item label="用户 ID">{p.user_id}</Descriptions.Item>
                <Descriptions.Item label="资产">{p.asset}</Descriptions.Item>
                <Descriptions.Item label="调整前">{p.balance_before}</Descriptions.Item>
                <Descriptions.Item label="变动">{p.delta}</Descriptions.Item>
                <Descriptions.Item label="调整后">
                  <strong>{p.balance_after}</strong>
                </Descriptions.Item>
              </Descriptions>
            )}
            onDone={() => {}}
          />
        </div>
      ) : (
        <p style={{ marginTop: 16, color: '#888' }}>请输入有效的用户 ID 以显示调整表单。</p>
      )}
    </div>
  );
}
